import ToolbarButton from './toolbar-button';

export * from './toolbar-button';

export default ToolbarButton;
